import { createI18n } from 'vue-i18n'
import en from './en.json'
import zhHant from './zh-Hant.json'
import id from "./id.json"
import hi from "./hi.json"
import { defaultLocale } from "@/app.config.js"

// 本站点只开放印尼语、英语、印地语、繁體中文，其余语言文件保留但不注册
const messages = {
	id,
	en,
	hi,
	'zh-Hant': zhHant,
}

// 本地存的是已下线的语言时回到默认语言
const getLocale = () => messages[uni.getLocale()] ? uni.getLocale() : defaultLocale;

const i18n = createI18n({
	legacy: false,
	globalInjection: true,
	locale: getLocale(),
	fallbackLocale: 'en',
	messages
})

uni.onLocaleChange(res => {
	i18n.global.locale.value = res.locale;
})

export default i18n;